<template>
  <div class="withdrawList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入商区码"
        size="small"
        class="param-input"
        clearable
        @change="getRefundList('status')"
        v-model="params.districtCode"
      ></el-input>
      <el-input
        placeholder="请输入订单id"
        size="small"
        class="param-input"
        clearable
        @change="getRefundList('status')"
        v-model="params.id"
      ></el-input>
      <el-input
        placeholder="请输入用户id"
        size="small"
        class="param-input"
        clearable
        @change="getRefundList('status')"
        v-model="params.uid"
      ></el-input>
      <el-button type="primary" size="small" @click="getRefundList('status')">搜索</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      border
      tyle="width: 100%"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column prop="id" label="订单id" align="center" width="220" fixed>
        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户id" align="center" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.uid || '未知'}}</span>
        </template>
      </el-table-column>   
           <el-table-column prop="name" label="用户名" align="center" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.name || '未知'}}</span>
        </template>
      </el-table-column>           
           <el-table-column prop="districtCode" label="商区码" align="center" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.districtCode || '未知'}}</span>
        </template>
      </el-table-column>    
      <el-table-column prop="money" label="税前金额(元)" align="center" width="160">
        <template slot-scope="scope">{{(scope.row.money/100 || 0) | numFormat}}</template>
      </el-table-column>
      <el-table-column prop="payMoney" label="提现金额（元）" align="center" width="120">
        <template slot-scope="scope">{{(scope.row.payMoney/100 || '0') | numFormat}}</template>
      </el-table-column>
      <el-table-column prop="payType" label="提现方式" align="center" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.payType === 'alipay'">支付宝</span>
          <span v-else-if="scope.row.payType === 'bankcard'">银行卡</span>
          <span v-else>未知方式</span>
        </template>
      </el-table-column>
      <el-table-column prop="withdrawType" label="提现类型" align="center" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.withdrawType === 0">代理提现</span>
          <span v-else-if="scope.row.withdrawType === 1">金币提现</span>
          <span v-else-if="scope.row.withdrawType === 2">商区提现</span>
        </template>
      </el-table-column>  
      <el-table-column prop="actName" label="账户持有人" align="center" width="160">
        <template slot-scope="scope">{{scope.row.actName || '未知'}}</template>
      </el-table-column>  
      <el-table-column  prop="act" label="提现账号" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.act || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">{{scope.row.status | withdrawStatus}}</template>
      </el-table-column>
      <el-table-column prop="statusDesc" label="状态说明" align="center" width="160">
        <template slot-scope="scope">{{scope.row.statusDesc || '暂无说明'}}</template>
      </el-table-column>
      <el-table-column  prop="createdAt" label="创建时间" align="center" width="160">
        <template slot-scope="scope">{{(scope.row.createdAt || '未知') | changeDate}}</template>
      </el-table-column>
      <!-- <el-table-column label="到账时间" align="center" width="160">
        <template slot-scope="scope">{{(scope.row.receivedAt || '未知') | changeDate}}</template>
      </el-table-column>

      <el-table-column label="回掉时间" align="center" width="160">
        <template slot-scope="scope">{{(scope.row.successAt || '未知') | changeDate}}</template>
      </el-table-column> -->

      <el-table-column prop="operating" label="操作" align="center" width="160" fixed="right">
        <template slot-scope="scope">
    <el-button type="success" size="mini"  @click="Refund(scope.row)">退款</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
        <!--退款弹窗-->
    <refund ref="Refund" @handlerTagList="getRefundList()"></refund>
  </div>
</template>
<script>
// import baseConfig from "@/utils/serverUrlConfig";
// import { paramsFilter } from "@/utils/global";
import {sortEscape} from "@/utils/global";
import Refund from "./components/refund";
import API from "@/api";

export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      time: "",
      loading: false,
      total: 0,
      flag: false,
      // 提现方式
      type: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "支付宝",
          value: "alipay"
        },
        {
          label: "银行卡",
          value: "bankcard"
        }
      ],
      // 提现状态
      status: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "未审核",
          value: 1
        },
        {
          label: "审核通过，转账中",
          value: 2
        },
        {
          label: "已拒绝",
          value: 3
        },
        {
          label: "未知错误",
          value: 4
        },
        {
          label: "提现成功",
          value: 5
        },
        {
          label: "提现失败",
          value: 6
        }
      ],
      // 请求订单列表参数
      params: {
        pageNumber: 1,
        pageSize: 20,
      }
    };
  },
  created() {
    this.getRefundList();
  },
  components:{Refund},

  methods: {
    // 请求订单列表
    getRefundList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getRefundList(this.params)
        .then(res => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getRefundList();
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getRefundList();
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.sortValue = sortEscape(column.order);
        this.params.sortKey = column.prop;
      } else {
        this.params.sortValue = "";
        this.params.sortKey = "";
      }
      this.getRefundList();
    },
   // 退款
   Refund(data){
       this.$refs.Refund.open(data)
   },
    // Refund(id) {
    //       this.$confirm('您确定要进行当前退款操作吗？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       API.Refund({ id: id }).then(res => {
    //         if (res.code === 200) {
    //           this.$message({
    //             message: '退款成功',
    //             type: 'success'
    //           });
    //           this.cashBankList()
    //         } else {
    //           this.$message.error('退款失败！');
    //         }
    //       })
    //     })
    // },
    // 弹窗关闭
    handleClose() {
      this.dialogVisible = false;
      this.statusDesc = "";
    }
  }
};
</script>

<style lang="scss">
.withdrawList-box {
  .update-box {
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 35px;
    color: #666;
    .el-input {
      width: 160px;
      margin-right: 10px;
      margin-left: 5px;
    }
    .el-button {
      margin-right: 10px;
      margin-left: 10px;
    }
  }
}
</style>
